<mat-form-field class="fill">
	<mat-label [innerHtml]="label"></mat-label>
	<input
		#input
		matInput
		[value]="text"
		(keyup)="onKeyUp($event)"
		[disabled]="formControl.disabled"
		[matAutocomplete]="auto"
	/>
	@if (allowClearing) {
		<button
			[disabled]="formControl.disabled || !value"
			matSuffix
			mat-icon-button
			mat-small-icon-button
			aria-label="Clear"
			(click)="onSelected(null); text = ''"
		>
			<mat-icon>close</mat-icon>
		</button>
	}

	<mat-autocomplete
		#auto="matAutocomplete"
		[displayWith]="displayWith"
		(optionSelected)="onSelected($event.option.value)"
		[requireSelection]="true"
		[autoActiveFirstOption]="true"
	>
		@for ($option of list; track trackBy()($index, $option)) {
			<mat-option [value]="$option">
				@if (itemTemplate()) {
					<ng-container
						*ngTemplateOutlet="
							itemTemplate();
							context: {
								$implicit: $option,
								$index: $index,
							}
						"
					></ng-container>
				} @else {
					{{ displayWith($option, $index) }}
				}
			</mat-option>
		}
	</mat-autocomplete>
</mat-form-field>
